'use client';

import { Checkbox } from '@magicschool/spellbook/components/Checkbox';
import type { ExpandedSubItemCheckboxProps } from './types';

export function ExpandedSubItemCheckbox({ subItem, selected = false, onToggle, disabled, showLabel = true }: ExpandedSubItemCheckboxProps) {
  return (
    <Checkbox
      label={subItem.label}
      showLabel={showLabel}
      checked={selected}
      onCheckedChange={(checked) => onToggle?.(subItem.id, checked === true)}
      disabled={disabled}
    />
  );
}
